export default {
  Form_Tips_Common: {
    enter_clinc_name: 'Please enter the clinic name',
    enter_clinc_code: 'Please enter the clinic code',
    enter_details_address: 'Please enter the details address',
    enter_phone: 'Please enter the phone number',
    select_administrator: 'Please select the administrator',
    letter_letters_numbers: 'Start letter, letters, numbers and hyphens only',
    QingShuRu_JingZhong: 'Please enter the Weight',
    XiuGai_MiMa_GuiZe:
      '*Must contain any three combinations of numbers, uppercase letters, lowercase letters, and special characters, with a length of 6 to 16 characters.',
    enter_project_name: 'Please enter the project name',
    enter_project_price: 'Please enter the project price',
    enter_project_duration: 'Please enter the project duration',
    enter_role_name: 'Please enter the role name',
    select_clinic_codes: 'Please select clinics',
    select_data_scope: 'Please select the permission scope',
    enter_product_name: 'Please enter the product name',
    enter_product_price: 'Please enter the product price',
    enter_new_password: 'Please enter a new password',
    enter_old_password: 'Please enter the current password',
    enter_new_account: 'Please enter the new account',
    enter_new_nickname: 'Please enter the new nickname',
    enter_new_en_name: 'Please enter the new English name',
    password_format_error: 'Incorrect password format',
    password_length_tip: 'Password must be 6‑16 characters',
    enter_keyword: 'Please enter the name or code',
    enter_name: 'Please enter the name',
    enter_code: 'Please enter the code',
    enter_org_code: 'Please enter the org code',
    enter_org_name: 'Please enter the org name',
    enter_batch_number: 'Please enter the batch number',
    enter_domain: 'Please enter the domain',
    un_available_option: 'No options',
    enter_password: 'Please enter the password',
    select_zhu_huanzhe: 'Please select the primary patient',
    select_dai_hebing: 'Please select patients to merge',
    select_org: 'Please select the org',
    enter_secret_name: 'Please enter the key name',
  },
}
